import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";

export default class PageKeywords extends BaseRootOption {
  static userInterfaceComponent = {
    label: "Keywords",
    component: inspectorTools.SIMPLE_INPUT,
    useDivider: false,
    useVerticalOrientation: true,
    props: {
      inputType: "textarea",
    },
  };

  static defaultValue = "";
}
